module.exports = __webpack_public_path__ + "img/heart-white.59004eb4.svg";